export function Leaf({ className = "h-5 w-5" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M12 2c4.5 4.5 4.8 12 0 19-4.8-7-4.5-14.5 0-19z" opacity=".95" />
      <path d="M12 6v15" stroke="#faf7f0" strokeWidth=".8" opacity=".5" />
    </svg>
  );
}

export function LeafVine({ className = "" }: { className?: string }) {
  return (
    <svg viewBox="0 0 200 400" className={className} fill="none" stroke="currentColor" strokeWidth="1" aria-hidden="true">
      <path d="M100 400C100 300 60 240 80 160S140 60 110 0" />
      {[60, 130, 200, 270, 340].map((y, i) => (
        <path key={y} d={i % 2 ? `M${92 - i} ${y}c-30-6-46-26-50-46 26 2 44 18 50 46z` : `M${88 + i} ${y}c30-6 46-26 50-46-26 2-44 18-50 46z`} />
      ))}
    </svg>
  );
}
